import Base from './base'
import { request, post, get } from './http'
import * as _ from 'lodash'

let METHOD = {
  GET: ['get', 'show'],
  POST: ['post', 'update', 'change', 'create', 'delete', 'remove', 'save']
}

function isJson (url, setting) {
  return _.isString(url) && !setting
}

class ApiService extends Base {
  constructor () {
    super()
    this.baseURL = '/api/web'
  }

  method_missing (property, ...args) {
    let [url, setting] = args

    if (_.isObject(url) || isJson(url, setting)) {
      setting = {
        data: url
      }

      if (_.isString(url)) {
        setting.contentType = 'application/json'
      }

      const url_parts = property.split('_')
      const method = url_parts[0].toLowerCase()

      if (METHOD.GET.includes(method)) {
        setting.method = 'GET'
        url_parts.shift()
      } else if (METHOD.POST.includes(method)) {
        setting.method = 'POST'
        url_parts.shift()
      } else {
        setting.method = 'GET'
      }

      url = '/' + url_parts.join('/')
    }

    return request(this.baseURL + url, setting)
  }

  login (params) {
    return post('/passport/auth', params)
  }

  logout () {
    return get('/passport/logout', {})
  }
}

export default new ApiService()
